var _path, _path2, _g, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToExpandBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4504 15.8058C12.2613 15.995 12.2613 16.3101 12.4504 16.4991L17.162 21.2107C17.2408 21.2895 17.3669 21.3368 17.4929 21.3525L17.5401 21.3525C17.6662 21.3368 17.7765 21.2895 17.8552 21.2107L22.5668 16.4991C22.756 16.31 22.756 15.9949 22.5668 15.8058C22.3777 15.601 22.0626 15.601 21.8577 15.8058L17.5086 20.1549L13.1596 15.8058C12.9704 15.601 12.6396 15.601 12.4504 15.8058Z",
    fill: "url(#paint0_linear_2247_2367)",
    stroke: "url(#paint1_linear_2247_2367)",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4504 8.8058C12.2613 8.99494 12.2613 9.31006 12.4504 9.49911L17.162 14.2107C17.2408 14.2895 17.3669 14.3368 17.4929 14.3525L17.5401 14.3525C17.6662 14.3368 17.7765 14.2895 17.8552 14.2107L22.5668 9.49911C22.756 9.30998 22.756 8.99486 22.5668 8.8058C22.3777 8.60094 22.0626 8.60094 21.8577 8.8058L17.5086 13.1549L13.1596 8.8058C12.9704 8.60094 12.6396 8.60094 12.4504 8.8058Z",
    fill: "url(#paint2_linear_2247_2367)",
    stroke: "url(#paint3_linear_2247_2367)",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2247_2367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 2C10.268 2 4 8.26801 4 16C4 23.732 10.268 30 18 30C25.732 30 32 23.732 32 16C32 8.26801 25.732 2 18 2Z",
    fill: "#FF6C37"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3389 17.8058C13.1644 17.995 13.1644 18.3101 13.3389 18.4991L17.6881 23.2107C17.7608 23.2895 17.8772 23.3368 17.9935 23.3525L18.0371 23.3525C18.1535 23.3368 18.2553 23.2895 18.328 23.2107L22.6771 18.4991C22.8517 18.31 22.8517 17.9949 22.6771 17.8058C22.5026 17.601 22.2117 17.601 22.0226 17.8058L18.008 22.1549L13.9935 17.8058C13.8189 17.601 13.5135 17.601 13.3389 17.8058Z",
    fill: "url(#paint4_linear_2247_2367)",
    stroke: "url(#paint5_linear_2247_2367)",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.054 10.8058C12.8795 10.995 12.8795 11.3101 13.054 11.4991L17.4032 16.2107C17.4759 16.2895 17.5923 16.3368 17.7086 16.3525L17.7522 16.3525C17.8686 16.3368 17.9704 16.2895 18.0431 16.2107L22.3922 11.4991C22.5668 11.31 22.5668 10.9949 22.3922 10.8058C22.2176 10.601 21.9268 10.601 21.7376 10.8058L17.7231 15.1549L13.7086 10.8058C13.534 10.601 13.2286 10.601 13.054 10.8058Z",
    fill: "url(#paint6_linear_2247_2367)",
    stroke: "url(#paint7_linear_2247_2367)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2247_2367",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2247_2367"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2247_2367",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2247_2367",
    x1: 16.9995,
    y1: 16.5005,
    x2: 16.9995,
    y2: 22.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2247_2367",
    x1: 12.3086,
    y1: 18.5023,
    x2: 22.7087,
    y2: 18.5023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2247_2367",
    x1: 16.9995,
    y1: 9.50046,
    x2: 16.9995,
    y2: 15.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2247_2367",
    x1: 12.3086,
    y1: 11.5023,
    x2: 22.7087,
    y2: 11.5023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2247_2367",
    x1: 17.5381,
    y1: 18.5005,
    x2: 17.5381,
    y2: 24.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2247_2367",
    x1: 13.208,
    y1: 20.5024,
    x2: 22.8081,
    y2: 20.5024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2247_2367",
    x1: 17.2532,
    y1: 11.5005,
    x2: 17.2532,
    y2: 17.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2247_2367",
    x1: 12.9231,
    y1: 13.5024,
    x2: 22.5232,
    y2: 13.5024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToExpandBackground);
export default __webpack_public_path__ + "static/media/ToExpandBackground.2d74ce5901953cdc7c4e191575be16c4.svg";
export { ForwardRef as ReactComponent };